module.exports = __webpack_public_path__ + "img/default_house_list.27e1ca20.jpg";